

import { EditData } from 'src/contracts/edit';
import { useLayoutStore } from 'stores/layout-store';
import {defineComponent} from 'vue';
import {storeToRefs} from 'pinia';
import {useGrouperStore} from 'stores/grouper-store';
import {useSearchStore} from 'stores/search-store';

export default defineComponent ({
  name: 'EditsSectionContainer',
  props: {
    sectionName: {
      type: String,
      required: true,
    },
    items: {
      type: Array<EditData>,
      required: true,
    },
    othersExpanded: {
      type: Boolean,
      required: false,
    },
  },
  setup() {
    return {
      editsSelectedCode: storeToRefs(useGrouperStore())
    }
  },
  methods: {
    hoverText(level: string | undefined): string {
      if (level === 'Critical') {
        return 'Critical Error doesn\'t allow override and DRG calculation cannot be completed.';
      }

      return 'Error Warning Does allow an override. TruBridge Encoder supplies the edit but it is up to the coder to ' +
          'determine if or how the edit should be resolved. DRG calculation can be completed, but inaccuracies may occur.';
    },
    // eslint-disable-next-line
    editsContent(description: any) {
      return description.replaceAll(/href="javascript:void\(0\)"/g, 'href="javascript:void(0)" class="clickable"');
    },
    // eslint-disable-next-line
    removeBRTags(description: any) {
      return description.replaceAll('<br>', ' ').replaceAll('<br/>', ' ')
          .replaceAll(/href="javascript:void\(0\)"/g, 'href="javascript:void(0)" class="clickable"');
    },
    // eslint-disable-next-line
    async editsClick(event: any) {
      const code = event.target.text;
      const diagnoseExist = useGrouperStore().diagnosisCodes.some(diagnose => diagnose.code === code);
      if(diagnoseExist) {
        useLayoutStore().setCodesSelected(true);
        useGrouperStore().changeSelectedCode(code)
      } else if (this.isProcedureCode(code)) {
        useLayoutStore().setSearchSelected(true);
        useSearchStore().setBookSelected('Procedure, ICD-10-PCS', false);
        useSearchStore().setModeSelected('table');
        useSearchStore().setSelectedProcedureCode(code);
      } else {
        useLayoutStore().setSearchSelected(true);
        useSearchStore().setBookSelected('Diagnosis, ICD-10-CM', false);
        useSearchStore().setModeSelected('index');
        useSearchStore().changeSearchText(code);
      }
    },
    isProcedureCode(code: string): boolean {
      // ICD-10-PCS codes are exactly 7 characters long and don't contain periods
      if (code.length !== 7) {
        return false;
      }
      
      // If the code contains a period, it's likely an ICD-10-CM diagnosis code
      if (code.includes('.')) {
        return false;
      }
      
      // ICD-10-PCS codes are all alphanumeric
      const pcsPattern = /^[0-9A-HJ-NP-Z]{7}$/;
      return pcsPattern.test(code);
    }
  }
})

